import { graphql } from 'gatsby';

import { PossibleHeaderComponents } from './header-section';

export const HeaderCampaignFragment = graphql`
  fragment HeaderCampaignFragment on STRAPI__COMPONENT_COMPONENTS_HEADER_CAMPAIGN {
    headerText
    ctaLabel
    ctaUrl
    piwikEventName
    strapi_component
  }
`;

export const componentName = 'components.header-campaign';

export type HeaderCampaignData = {
  headerText?: string | null;
  ctaLabel: string;
  ctaUrl: string;
  piwikEventName?: string | null;
};

export type HeaderCampaign = {
  strapi_component: typeof componentName;
} & HeaderCampaignData;

export const isHeaderCampaign = (
  component: PossibleHeaderComponents,
): component is HeaderCampaign => {
  return component.strapi_component === componentName;
};
